import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {L} from "../lt-ng/landcare-toolkit";
import filterNodes = L.tree.filterNodes;
import {Map as OlMap} from 'ol';
import View from "ol/View";
import {_F} from "../utility/func";
import updateMapSizeWhenVisible = _F.updateMapSizeWhenVisible;
import {defaults} from "ol/control";

/**
 * Created by tom on 11/04/17.
 *
 * A directive to create an OpenLayers map.
 *
 * This map will ape the view settings of the OlMap in the landcareMapService - but only display tile layers.
 *
 * The map will $emit the event ol-map upon initialisation - parent $scope's can subscribe to this event
 * to get access to the directive's OlMap object
 *
 * Parent $scopes that $broadcast ol-get-map will get a response from this directive via the ol-map event.
 */
export class MapView implements ng.IDirective {
	restrict = 'E'; //attribute or element
	transclude = true;
	replace = true;
	elementClass = 'lt-map-view';
	template = '<div class="' + this.elementClass + '"></div>';
	scope = {
		ltResolutions: '=',
		ltLayerFilter: '='
	};
	map : OlMap = null;
	constructor(protected mapService : IMapService) {
		this.link = ($scope: ng.IScope, element: ng.IAugmentedJQuery,
					 attrs: ng.IAttributes) => {

			let zoom = 0;
			$scope.$on('map-zoom-scale', (ev, scale : number, scales : number[]) => {
				if (this.map instanceof OlMap) {
					let idx = scales.indexOf(scale);
					zoom = idx != -1 ? idx : 0;
					this.map.getView().setZoom(zoom);
				}
			});

			mapService.promise.then(() => {
				let layerItems = filterNodes(mapService.treeData, (n) => n.layer);

				if ($scope['ltLayerFilter']) {
					layerItems = layerItems.filter($scope['ltLayerFilter']);
				}

				let layers = layerItems.map((n) => n.layer);

				let currentMap = mapService.map;
				if (!currentMap) return;
				let view = currentMap.getView();

				let viewOptions = {
					center : view.getCenter(),
					zoom: view.getZoom(),
					projection: view.getProjection(),
					resolutions: view.getResolutions()
				};

				const target = element[0];

				let map = new OlMap({
					// only show tile layers
					layers,
					 view: new View(viewOptions),
					target: element[0],
					keyboardEventTarget: document,
					controls: defaults({
						attributionOptions: {
							collapsible: false
						},
						rotate: false
					})
				});
				this.map = map;

				map.on('moveend', (event) => {
					$scope.$emit('map-move', event);
				});

				$scope.$emit('ol-map', map);

				updateMapSizeWhenVisible(map);

				window['printMap'] = map;
			});

			$scope.$on('ol-get-map', () => {
				$scope.$emit('ol-map', this.map);
			});
		};
	}

	link: ($scope: ng.IScope, elem: ng.IAugmentedJQuery,
		   attrs: ng.IAttributes) => void = null;

	static factory(): ng.IDirectiveFactory {
		const directive = (mapService : IMapService ) => new MapView(mapService);
		directive.$inject = ['landcareMapService'];
		return directive;
	}
}